var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file MiniInput组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './MiniInput.less';

import Input from './Input.js';
/**
 * 参数说明
 * value                可选，默认值
 * onHandleChange       忽略，form专用，内部方法
 * id                   可选，唯一id
 * name                 可选，如果没有此项，会自动生成一个
 * increment            忽略，form专用，内部属性，唯一标识
 * formFlag             忽略，form专用，内部属性
 * getValue             可选，获取数据
 * type                 可选，input的type属性
 * countFlag            可选，是否需要计数
 * max                  可选，最大输入字符个数
 * onClick              可选，点击触发
 * onKeyDown            可选，键盘按键时触发
 * horizontal           可选，水平排列
 * vertical             可选，垂直排列，默认垂直
 * noDistance           可选，此项为true，input下的24px消失
 * width                可选，自定义宽度，默认为400px
 * height               可选，自定义高度，默认为40px
 * className            可选，自定义class
 * style                可选，自定义样式
 * readOnly             可选，只读
 * noWarning            可选，不要提示警告
 * classPrefix          可选，class前缀
 * placeHolder          可选，placeholder
 * validate             可选，验证信息
 * disabled             可选，不可用态
 * label                可选，label说明
 * star                 可选，是否必填的*号
 * tips                 可选，后面的说明文字
 * className            可选，自定义class
 * autoComplete         可选，是否应该启用自动完成功能 on开启 off关闭
 * countWay             可选, 字数统计的展现形式length,character,characterInt。默认为length
 * countComplete        可选，是否完整显示计数(默认超过99会显示99+)
 */

var MiniInput = function (_Component) {
    _inherits(MiniInput, _Component);

    function MiniInput() {
        _classCallCheck(this, MiniInput);

        return _possibleConstructorReturn(this, (MiniInput.__proto__ || Object.getPrototypeOf(MiniInput)).apply(this, arguments));
    }

    _createClass(MiniInput, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                horizontal = _props.horizontal;

            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-mini-input', true), _defineProperty(_classnames, 'display-i-b', horizontal), _classnames));
            return React.createElement(
                'div',
                { className: rootClass },
                React.createElement(Input, _extends({}, this.props, {
                    height: '32px',
                    noDistance: true,
                    noWarning: true,
                    star: false
                }))
            );
        }
    }]);

    return MiniInput;
}(Component);

MiniInput.propTypes = {
    classPrefix: PropTypes.string,
    horizontal: PropTypes.bool
};
MiniInput.defaultProps = {
    classPrefix: 'spui'
};
export default MiniInput;